import { render, staticRenderFns } from "./SecondSettingsComp.vue?vue&type=template&id=78673abe&scoped=true&"
import script from "./SecondSettingsComp.vue?vue&type=script&lang=js&"
export * from "./SecondSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./SecondSettingsComp.vue?vue&type=style&index=0&id=78673abe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78673abe",
  null
  
)

export default component.exports